import { css } from 'styled-components'
import { vw } from './config'

const rem = {
  baseMobile: 15,
  base: 18,
  get: (value:number, factor = null) => `${value / (factor ?? rem.baseMobile)}rem`
}

export const vwFont = (size: number, mobile: boolean = true) => rem.get(size, rem[mobile ? 'baseMobile' : 'base'])


// TOASTS & ERROR PAGES
export const font12_normal = (mobile: boolean = true, weight: 400 | 500 = 400) => css`
  font-size: ${rem.get(12, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: normal;
`

export const font40_normal = (mobile: boolean = true, weight: 300 | 400 = 300) => css`
  font-size: ${rem.get(40, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: normal;
  letter-spacing: -.8px;
`

export const font30_normal = (mobile: boolean = true, weight: 300 | 400 = 300) => css`
  font-size: ${rem.get(30, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: normal;
  letter-spacing: -.6px;
`
// END TOAST & ERROR PAGES

// PROJECT
export const font10 = (mobile: boolean = true, weight: 300 | 400 = 400) => css`
  font-size: ${rem.get(10, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: 130%;
  letter-spacing: ${vw(.3, mobile ? 'mobile' : 'desktop')};
`

export const font12 = (mobile: boolean = true, weight: 300 | 400 = 400) => css`
  font-size: ${rem.get(12, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: 125%;
  letter-spacing: ${vw(.24, mobile ? 'mobile' : 'desktop')};
`
export const font12_Nav = (mobile: boolean = true, weight: 300 | 400 = 400) => css`
  font-size: ${rem.get(12, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: 125%;
  letter-spacing: ${vw(.24, mobile ? 'mobile' : 'desktop')};
`

export const font15 = (mobile: boolean = true, weight: 300 | 400 = 400) => css`
  font-size: ${rem.get(15, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: 120%;
  letter-spacing: -${vw(.15, mobile ? 'mobile' : 'desktop')};
`

export const font18 = (mobile: boolean = true, weight: 300 | 400 = 400) => css`
  font-size: ${rem.get(mobile? 16 :18, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: 130%;
  /* letter-spacing: -${vw(15 / 300, mobile ? 'mobile' : 'desktop')}; */
  `

export const font20 = (mobile: boolean = true, weight: 300 | 400 = 400) => css`
  font-size: ${rem.get(mobile? 18 :20, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: 130%;
  /* letter-spacing: -${vw(15 / 300, mobile ? 'mobile' : 'desktop')}; */
  `

export const font25 = (mobile: boolean = true, weight: 300 | 400 = 400) => css`
  font-size: ${rem.get(mobile? 20:25, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: 130%;
  /* letter-spacing: -0.25px; */
  letter-spacing: -${vw(.25, mobile ? 'mobile' : 'desktop')};
`
export const font30 = (mobile: boolean = true, weight: 300 | 400 = 400) => css`
  font-size: ${rem.get(mobile? 20: 30, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: 120%;
  letter-spacing: -${vw(.3, mobile ? 'mobile' : 'desktop')};
`

export const font50 = (mobile: boolean = true, weight: 300 | 400 = 400) => css`
  font-size: ${rem.get(mobile? 30: 50, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: 110%;
  letter-spacing: -${vw(mobile ? .6 : 50 / 100, mobile ? 'mobile' : 'desktop')};
`
